import * as React from 'react';

const useIsVisible = <T extends Element>(ref?: React.RefObject<T>) => {
  const [isIntersecting, setIsIntersecting] = React.useState(false);

  React.useEffect(() => {
    const myRef = ref?.current;
    if (!myRef) {
      return undefined;
    }

    const obs = new IntersectionObserver((entries) => {
      setIsIntersecting(entries[0].isIntersecting);
    });

    obs.observe(myRef);

    return () => {
      obs.unobserve(myRef);
    };
  }, []);

  return isIntersecting;
};

export default useIsVisible;
